import { render, staticRenderFns } from "./PaymentAndDelivery.vue?vue&type=template&id=21079d84&scoped=true&"
import script from "./PaymentAndDelivery.vue?vue&type=script&lang=js&"
export * from "./PaymentAndDelivery.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAndDelivery.vue?vue&type=style&index=0&id=21079d84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21079d84",
  null
  
)

export default component.exports